<template>
    <mc-container :title="title">
        <div :name="name">
            <slot></slot>
        </div>
    </mc-container>
</template>

<script>
    import McContainer from './base-container'
    import { oneOf, findComponentsDownward } from '../utils/assist';
    import Emitter from '../mixins/emitter';

    let seed = 0;
    const now = Date.now();
    const getUuid = () => `ivuRadioGroup_${now}_${seed++}`;

    export default {
        name: "mc-radio-group",
        mixins: [Emitter],
        components: {
            McContainer
        },
        props: {
            value: {
                type: [String, Number],
                default: ''
            },
            title: {
                type: String,
                description: '分组单选框标题'
            },
            name: {
                type: [String, Number],
                default: getUuid
            }
        },
        data: function(){
            return {
                currentValue: this.value,
                children: []
            }
        },
        mounted () {
            this.updateValue();
        },
        methods: {
            updateValue: function(){
                this.children = findComponentsDownward(this.$children[0], 'mc-radio');
                if(this.children){
                    this.children.forEach(child => {
                        child.currentValue = this.value === child.label;
                        child.group = true;
                    })
                }
            },
            change: function(data){
                this.currentValue = data.value;
                this.updateValue();
                this.$emit('input', data.value);
                this.$emit('change', data.value);
            }
        },
        watch: {
            value: function(val){
                this.currentValue = this.value;
                this.updateValue();
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/base-radio-group.vue